import InputLabel from '@mui/material/InputLabel'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputAdornment from '@mui/material/InputAdornment'
import FormHelperText from '@mui/material/FormHelperText'
import React, { ChangeEvent } from 'react'
import FormControl from '@mui/material/FormControl'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { SxProps } from '@mui/material'
import Stack from '@mui/material/Stack'
import { LabelChip } from './LabelChip'

interface LabelColorPickerProps {
	register: UseFormRegister<any>
	errors: FieldErrors<any>
	labelName: string
	labelColor: string
	onColorChange: (value: string) => void
	labelId: string
	styles: SxProps
}

export const LabelColorPicker = (props: LabelColorPickerProps) => {
	const {
		register,
		errors,
		labelName,
		labelColor,
		onColorChange,
		labelId,
		styles = {}
	} = props

	const handleLabelColorChange = (e: ChangeEvent<HTMLInputElement>) => {
		onColorChange(e.target.value)
	}

	return (
		<Stack direction="column" spacing={2}>
			<FormControl
				variant="outlined"
				required
				sx={{ width: '32rem', margin: '0', ...styles }}
				error={!!errors?.labelColor?.message}
			>
				<InputLabel shrink={!!labelColor} htmlFor={labelId}>
					Label color
				</InputLabel>
				<OutlinedInput
					id={labelId}
					label="Label color"
					{...register?.('labelColor', {
						pattern: {
							value: /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/,
							message: 'Make sure color is a valid hex format'
						}
					})}
					value={labelColor}
					onChange={handleLabelColorChange}
					endAdornment={
						<InputAdornment position="end">
							<input
								style={{ width: '2rem' }}
								onChange={handleLabelColorChange}
								type="color"
								name="labelColor"
								value={labelColor}
							/>
						</InputAdornment>
					}
				/>
				{errors?.labelColor?.message && (
					<FormHelperText>
						{errors?.labelColor?.message as React.ReactNode}
					</FormHelperText>
				)}
			</FormControl>
			<LabelChip
				labelColor={labelColor}
				labelName={labelName}
			/>
		</Stack>

	)
}